<!-- <div *ngIf="products">
    <pre>
        {{brandCollectionList | json}}
    </pre>
</div> -->

<app-breadcrumb [title]="'Collection'" [breadcrumb]="'Collection'">

</app-breadcrumb>
<!-- section start -->
<section class="section-b-space">
    <div class="collection-wrapper">
        <div class="container">
            <div class="row">
                <div class="col-lg-3">
                    <div class="collection-filter" [class.openFilterbar]="mobileSidebar">
                        <app-Market></app-Market>
                    </div>
                </div>


                <div class="collection-content col">
                    <div class="page-main-content">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="row">
                                    <div class="col-xl-12">
                                        <div class="filter-main-btn" (click)="toggleMobileSidebar()">
                                            <span class="filter-btn btn btn-theme">
                                                <i class="fa fa-search" aria-hidden="true"></i> {{'Markets'|translate}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="collection-product-wrapper" id="products">
                                    <input value="'www.amazon.com'">
                                    <div class="product-wrapper-grid" [ngClass]="layoutView">
                                        <div class="mt-3 text-center">
                                            <iframe src="https://www.amazon.com/gp/video/offers/signup/?ie=UTF8&benefitID=eurocinema" width="340" height="500" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe>
                                        </div>
                                    </div>



                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- section End -->